import axios from 'axios';

const baseURL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = 'tc_token';

export const api = axios.create({ baseURL });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      // token invalid/expired — clear it so ProtectedRoute can redirect
      const path = window.location.pathname;
      if (path.startsWith('/admin') && path !== '/admin/login') {
        localStorage.removeItem(TOKEN_KEY);
        window.location.assign('/admin/login');
      }
    }
    return Promise.reject(err);
  }
);

export const formatApiError = (e, fallback = 'Something went wrong.') => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(' ');
  return JSON.stringify(d);
};
